
import React from 'react';
import PropTypes from 'prop-types';
import ArrowRightAlt from '../../../element/icons/arrow-right-alt';
import Point from '../../../element/icons/point';

import { POSITIONS } from '../../../utils/constants';
import mapPositionStringToPoint from '../../../utils/mapPositionStringToPoint';
import { useStore } from '../../../hooks';
import {
  StyledIconWrapper,
  StyledPositionGrid,
  StyledSpacedOptionFields,
} from './AnnotationOptions.styled';
import {
  AVAILABLE_POSITIONS,
  posCssRotateDegFromRightSide,
} from './AnnotationOptions.constants';

const PositionFields = ({ annotation, updateAnnotation, t }) => {
  const { designLayer } = useStore();

  const changePosition = (newPositionStr) => {
    updateAnnotation(
      mapPositionStringToPoint(annotation, designLayer, newPositionStr),
    );
  };

  return (
    <StyledSpacedOptionFields className="respark_annotation-option-panel respark_annotation-option-panel--position">
      <StyledPositionGrid>
        {AVAILABLE_POSITIONS.map((pos) => (
          <StyledIconWrapper
            key={pos}
            onClick={() => changePosition(pos)}
            secondaryIconColor
            addThinBorder
            noMargin
          >
            {pos === POSITIONS.MIDDLE_CENTER ? (
              <Point size={18} />
            ) : (
              <ArrowRightAlt
                size={18}
                style={{
                  transform: `rotate(${posCssRotateDegFromRightSide[pos]}deg)`,
                }}
              />
            )}
          </StyledIconWrapper>
        ))}
      </StyledPositionGrid>
    </StyledSpacedOptionFields>
  );
};

PositionFields.propTypes = {
  annotation: PropTypes.instanceOf(Object).isRequired,
  updateAnnotation: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default PositionFields;
